var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "input-group", class: { open: _vm.open } }, [
    _c("label", { on: { click: _vm.toggle } }, [
      _vm._v(_vm._s(_vm._f("trans")("feelgrid:devices.select.label")))
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "value form-control" }, [
      _vm.value.length
        ? _c("ins", { on: { click: _vm.toggle } }, [
            _vm._v(_vm._s(_vm._f("text")(_vm.chosen_names.join(", "))))
          ])
        : _c("ins", { staticClass: "faded", on: { click: _vm.toggle } }, [
            _vm._v(_vm._s(_vm._f("trans")("feelgrid:devices.select.none")))
          ]),
      _vm._v(" "),
      _vm.open
        ? _c(
            "ul",
            { staticClass: "drop" },
            [
              _c("li", { staticClass: "all" }, [
                _c(
                  "label",
                  { staticClass: "checkbox sm", on: { click: _vm.all } },
                  [
                    _c("span", [
                      _vm._v(
                        _vm._s(_vm._f("trans")("feelgrid:devices.select.all"))
                      )
                    ])
                  ]
                )
              ]),
              _vm._v(" "),
              _vm._l(_vm.devices, function(device) {
                return _c("li", [
                  _c("label", { staticClass: "checkbox sm" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.selected,
                          expression: "selected"
                        }
                      ],
                      attrs: { type: "checkbox" },
                      domProps: {
                        value: device.item.id,
                        checked: Array.isArray(_vm.selected)
                          ? _vm._i(_vm.selected, device.item.id) > -1
                          : _vm.selected
                      },
                      on: {
                        change: function($event) {
                          var $$a = _vm.selected,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = device.item.id,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 && (_vm.selected = $$a.concat([$$v]))
                            } else {
                              $$i > -1 &&
                                (_vm.selected = $$a
                                  .slice(0, $$i)
                                  .concat($$a.slice($$i + 1)))
                            }
                          } else {
                            _vm.selected = $$c
                          }
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("i"),
                    _vm._v(" "),
                    _c("span", [_vm._v(_vm._s(_vm._f("text")(device.name)))])
                  ])
                ])
              })
            ],
            2
          )
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-72294e12", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-72294e12","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/apps/feelgrid/assets/DeviceSelector.vue
// module id = null
// module chunks = 